import React from 'react';
import moment from 'moment';
import {typography} from 'material-ui/styles';
import IconButton from 'material-ui/IconButton';
import LeftIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import RightIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-right';

const styles = {
  container:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#31B181',
    width:'99%',
    color: 'white'
  },
  date:{
    fontSize: 18,
    fontWeight: typography.fontWeightNormal,
  }
}

const disablePrev = (date)=>{
  let today = moment();
  if(today.isSame(date,'day'))
    return true;
  else
    return false;
}

const ToolBar = ({date,onNext,onPrevious}) => (
  <div>
    <br/>
    <div style={styles.container}>
      <IconButton disabled={disablePrev(date)} onTouchTap={onPrevious}>
        <LeftIcon/>
      </IconButton>
      <span style={styles.date}> {moment(date).format('Do MMMM, YYYY')} </span>
      <IconButton onTouchTap={onNext}>
        <RightIcon/>
      </IconButton>
    </div>
  </div>
);

export default ToolBar;


// WEBPACK FOOTER //
// ./src/screens/schedules/toolbar.js